
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 22","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"d":"M0 4a4 4 0 014-4h16a4 4 0 014 4v10.99a4 4 0 01-3.864 3.999l-4.536.154L12 22l-3.6-2.857-4.536-.154A4 4 0 010 14.99V4z"}})]),_c('path',{attrs:{"d":"M5 6.75h14v-1.5H5v1.5zm0 5h9v-1.5H5v1.5zM12 22l-.932 1.175.932.74.932-.74L12 22zm-3.6-2.857l.932-1.175-.387-.308-.494-.016-.051 1.499zm7.2 0l-.051-1.5-.494.017-.387.308.932 1.175zm-11.736-.154l-.051 1.499.051-1.5zm16.272 0l.051 1.499-.051-1.5zM4 1.5h16v-3H4v3zM22.5 4v10.99h3V4h-3zm-21 10.99V4h-3v10.99h3zm11.432 5.835l-3.6-2.857-1.864 2.35 3.6 2.857 1.864-2.35zm-4.481-3.181l-4.536-.155-.102 2.999 4.536.154.102-2.998zm11.634-.155l-4.536.155.102 2.998 4.536-.154-.102-2.999zm-5.418.479l-3.6 2.857 1.865 2.35 3.6-2.857-1.864-2.35zM-1.5 14.99a5.5 5.5 0 005.313 5.497l.102-2.999A2.5 2.5 0 011.5 14.991h-3zm24 0a2.5 2.5 0 01-2.415 2.498l.102 2.999A5.5 5.5 0 0025.5 14.99h-3zM20 1.5A2.5 2.5 0 0122.5 4h3A5.5 5.5 0 0020-1.5v3zm-16-3A5.5 5.5 0 00-1.5 4h3A2.5 2.5 0 014 1.5v-3z","mask":"url(#a)"}})])
          )
        }
      }
    